<template>
  <div  :class="keyboardClass"></div>
</template>

<script>
import Keyboard from "simple-keyboard";
import "simple-keyboard/build/css/index.css";

export default {
  name: "SimpleKeyboard",
  props: {
    keyboardClass: {
      default: "simple-keyboard",
      type: String
    },
    input: {
      type: String
    },
    init: {
      type: String,
      default: ''
    },
    numeric:false,
    phone:false,
  },
  data: () => ({
    keyboard: null
  }),
  mounted() {
    if(this.numeric) {
      this.keyboard = new Keyboard(this.keyboardClass, {
        onChange: this.onChange,
        onKeyPress: this.onKeyPress
      });
    }
    else if(this.phone) {
      this.keyboard = new Keyboard(this.keyboardClass, {
        onChange: this.onChange,
        onKeyPress: this.onKeyPress,
        layout:{'default':[
            '7 8 9',
            '4 5 6',
            '1 2 3',
            '0 {bksp}',
          ]}
      });
    }
    else {
      this.keyboard = new Keyboard(this.keyboardClass, {
        onChange: this.onChange,
        onKeyPress: this.onKeyPress,
        layout:{'default':[
            '7 8 9',
            '4 5 6',
            '1 2 3',
            '0 00 000',
            '{bksp}'
          ]}
      });
    }

    if(this.init.toString() != '') {
      var v = this.init.toString()
      //if(this.numeric)
      {
        v = v.replace(/,/gi, "");
      }
      this.keyboard.setInput(v)
    }
  },
  methods: {
    onChange(input) {
      this.$emit("onChange", input);
    },
    onKeyPress(button) {
      this.$emit("onKeyPress", button);

      /**
       * If you want to handle the shift and caps lock buttons
       */
      if (button === "{shift}" || button === "{lock}") this.handleShift();
    },
    handleShift() {
      let currentLayout = this.keyboard.options.layoutName;
      let shiftToggle = currentLayout === "default" ? "shift" : "default";

      this.keyboard.setOptions({
        layoutName: shiftToggle
      });
    }
  },
  watch: {
    input(input) {
      this.keyboard.setInput(input);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
